var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.382,
    height: 35.382,
    viewBox: "0 0 35.382 35.382",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_757",
    "data-name": "Rectangle 757",
    width: 35.382,
    height: 35.382,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1466",
    "data-name": "Group 1466",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1465",
    "data-name": "Group 1465",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69264",
    "data-name": "Path 69264",
    d: "M35.382,17.691A17.691,17.691,0,1,1,17.691,0,17.691,17.691,0,0,1,35.382,17.691",
    fill: "#3cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69265",
    "data-name": "Path 69265",
    d: "M27.465,11.629a7.971,7.971,0,0,1-1.951.556c.314-.052.774-.62.959-.85a3.59,3.59,0,0,0,.648-1.181c.017-.034.029-.076,0-.1a.111.111,0,0,0-.1.009,9.974,9.974,0,0,1-2.313.885.155.155,0,0,1-.16-.042,1.807,1.807,0,0,0-.2-.207,4.106,4.106,0,0,0-1.121-.686A3.886,3.886,0,0,0,21.5,9.734a4.115,4.115,0,0,0-1.63.46,4.2,4.2,0,0,0-1.316,1.075,4.034,4.034,0,0,0-.785,1.573,4.242,4.242,0,0,0-.042,1.661c.013.093,0,.106-.08.093A12.358,12.358,0,0,1,9.7,10.55c-.093-.106-.143-.106-.219.008a4.03,4.03,0,0,0,.687,4.763c.156.148.316.3.488.43a4.063,4.063,0,0,1-1.534-.43c-.092-.059-.139-.025-.147.08A2.381,2.381,0,0,0,9,15.857a4.076,4.076,0,0,0,2.512,3.249,2.315,2.315,0,0,0,.51.156,4.58,4.58,0,0,1-1.505.047c-.109-.021-.151.033-.109.139a4.233,4.233,0,0,0,3.161,2.647c.143.025.286.025.43.058-.009.013-.017.013-.025.026a5.008,5.008,0,0,1-2.159,1.144,7.745,7.745,0,0,1-3.279.42c-.176-.026-.213-.024-.261,0s-.006.072.051.117c.223.148.451.279.682.4a10.837,10.837,0,0,0,2.192.877,11.674,11.674,0,0,0,11.333-2.65,11.893,11.893,0,0,0,3.136-8.676c0-.124.148-.193.235-.259a7.643,7.643,0,0,0,1.542-1.6.481.481,0,0,0,.1-.307v-.017c0-.051,0-.036-.079,0",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter_logo.0c64fbcedff81084ebb95e246a136b25.svg";
export { ForwardRef as ReactComponent };